package floris.graphics.landing.pages.projects.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.constants.Res
import com.materialdesignsystem.toColorScheme
import floris.graphics.models.domain.models.project.ProjectDetail
import org.jetbrains.compose.web.css.px

@Composable
fun ContributorAndTechstackInfo(
    modifier: Modifier = Modifier,
    breakpoint: Breakpoint,
    detail: ProjectDetail
) {
    Column(
        modifier = modifier.rowGap(6.px)
    ) {
        ContributorRow(
            labelText = Res.String.AgencyLabel,
            contributor = detail.agency
        )

        ContributorRow(
            labelText = Res.String.DesignLabel,
            contributor = detail.design
        )

        ContributorRow(
            labelText = Res.String.ClientLabel,
            contributor = detail.client
        )

        ContributorRow(
            labelText = Res.String.AnimatorLabel,
            contributor = detail.animator
        )

        Row(
            modifier = Modifier
                .margin(top = if (breakpoint > Breakpoint.LG) 38.px else 24.px)
                .columnGap(4.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            detail.techstacks.orEmpty().forEach {
                Image(
                    modifier = Modifier
                        .background(ColorMode.current.toColorScheme.inversePrimary)
                        .padding(4.px)
                        .size(28.px)
                        .borderRadius(4.px),
                    src = it.logoMediaFile?.url?.toString() ?: ""
                )
            }
        }
    }
}